<template>
  <div class="xiaomi">
    <div class="header">
      <p>
        {{ app.header.tip1 }}
      </p>
    </div>
    <div class="container">
      <div class="container-title">
        <div class="num">1</div>
        <div class="title-word">
          {{ app.content.list1.title }}
        </div>
      </div>
      <div class="content">
        <img src="../assets/xiaomi-1.png" alt="" />
        <img src="../assets/xiaomi-2.png" alt="" />
        <img src="../assets/xiaomi-3.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">2</div>
        <div class="title-word">{{ app.content.list2.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/xiaomi-4.png" alt="" />
        <img src="../assets/xiaomi-5.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">3</div>
        <div class="title-word">
          {{ app.content.list3.title }}
        </div>
      </div>
      <div class="content">
        <img src="../assets/xiaomi-6.png" alt="" />
        <img src="../assets/xiaomi-7.png" alt="" />
        <img src="../assets/xiaomi-8.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import zh from "@/locales/xiaomi/zh";
import en from "@/locales/xiaomi/en";
import { toggleLang } from "@/mixins/toggleLang";
export default {
  name: "xiaomi",
  mixins: [toggleLang],
  created() {
    this.toggle(zh, en);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
